// Phase 11 — `useNow` hook.
//
// Returns the server-corrected wall-clock as an epoch in milliseconds,
// re-sampled once per second so present-time displays (the progress
// timeline's chip, derived progress fractions) advance smoothly without
// waiting for the next `/tick`. Mirrors `useElapsedSeconds` /
// `useCountdown`: 1 s granularity, recomputed from the corrected clock so
// it can never drift. The food does not pause, so neither does this.

import { useEffect, useState } from 'react';
import { correctedNow } from './helpers';

export function useNow(clockOffset: number): number {
  const [now, setNow] = useState<number>(() => correctedNow(clockOffset));

  useEffect(() => {
    setNow(correctedNow(clockOffset));
    const id = setInterval(() => {
      setNow(correctedNow(clockOffset));
    }, 1000);
    return () => clearInterval(id);
  }, [clockOffset]);

  return now;
}
